import api from "../../services/newApi/api";
import type { IActiveConvenio } from "./types";

const STORAGE_KEY = "convenio_active";

export function setActiveConvenioStorage(convenio: IActiveConvenio | undefined) {
  if (!convenio) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(convenio));
}

export function getActiveConvenioStorage(): IActiveConvenio | undefined {
  const json = localStorage.getItem(STORAGE_KEY);
  if (!json) return undefined;
  return JSON.parse(json) ?? undefined;
}

export const getLastConvenioSelected = async (): Promise<IActiveConvenio | undefined> => {
  const response = await api.get<{ status: string; data: { id: number; cd_convenio: number; ds_convenio?: string; permissions?: number[] } }>(
    `/users/convenio/list`,
  );
  const convenio = response.data.data;
  if (!convenio?.cd_convenio) return undefined;
  return {
    cd_convenio: convenio.cd_convenio,
    ds_convenio: convenio.ds_convenio,
    permissions: convenio.permissions ?? [3],
  };
};
